export default __webpack_public_path__ + "static/weekmenu-8320c79b5e242f58b24db14ba1bd9985.mp4";